import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

interface ILoginResponse {
  message: string;
  payload: {
    accessToken: string;
    refreshToken: string;
    requirePasswordChange: boolean;
  };
}

interface IRegisterResponse {
  message: string;
}

interface IResetPasswordResponse {
  message: string;
}

interface ILogoutResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private api: ApiService) {}

  login(email: string, password: string): Observable<ILoginResponse> {
    return this.api.POST<ILoginResponse>('auth/login', {
      identifier: email,
      password,
    })
  }
  
  loginAdmin(email: string, password: string): Observable<ILoginResponse> {
    return this.api.POST<ILoginResponse>('auth/admin/login', {
      email,
      password,
    });
  }

  logout(): Observable<ILogoutResponse> {
    return this.api.POST<ILogoutResponse>('auth/logout', {});
  }

  register(requestBody: {
    email: string;
    password: string;
    fullName: string;
    nationalIdNumber: string;
    phoneNumber: string;
    gender: string;
  }): Observable<IRegisterResponse> {
    return this.api.POST<IRegisterResponse>(
      'auth/register',
      requestBody
    );
  }

  requestPasswordReset(
    identifier: string,
    notificationMethod: string,
  ): Observable<IResetPasswordResponse> {
    const userGroup = "CITIZEN_GROUP";
    return this.api.POST<IResetPasswordResponse>(
      'auth/request-reset-password',
      {
        identifier,
        notificationMethod,
        userGroup,
      }
    );
  }

  resetPassword(
    code: string,
    newPassword: string
  ): Observable<IResetPasswordResponse> {
    return this.api.POST<IResetPasswordResponse>(
      'auth/reset-password',
      {
        code,
        newPassword,
      }
    );
  }
}
